const topics = [
  { id: 1, name: '科幻大片', hot: true, count: '2.3万讨论' },
  { id: 2, name: '悬疑反转', hot: true, count: '1.8万讨论' },
  { id: 3, name: '韩剧推荐', hot: true, count: '3.1万讨论' },
  { id: 4, name: '国产好剧', hot: false, count: '1.5万讨论' },
  { id: 5, name: '动作猛片', hot: false, count: '9800讨论' },
  { id: 6, name: '恐怖惊悚', hot: true, count: '1.2万讨论' },
  { id: 7, name: '治愈动画', hot: false, count: '8600讨论' },
  { id: 8, name: '纪录片', hot: false, count: '6200讨论' },
  { id: 9, name: '经典重温', hot: false, count: '7400讨论' },
  { id: 10, name: '新片速递', hot: true, count: '4.5万讨论' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">影迷们正在热烈讨论的话题标签</p>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((t) => (
            <span
              key={t.id}
              className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-xs"></i>}
              #{t.name}
              <span className="text-xs opacity-60 ml-1">{t.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}